import React, {CSSProperties} from 'react';
import {Icon, PriorityIcon, TriggerWrapperV2, Flex} from '@priority-software/priority-style-react';
import {Label} from '../../../../../../components/Common/Label';
import cx from 'classnames';
import styles from './styles.module.scss';

type Props = {
    icon: PriorityIcon;
    disabled?: boolean;
    title?: string;
    width: number;
    iconStyle?: CSSProperties;
    isOpen: boolean;
    componentClasses?: string;
    onClose: (e?: Event) => void;
};

export const FilterIconTrigger = ({
    icon,
    disabled = false,
    title = '',
    width,
    iconStyle,
    isOpen,
    componentClasses,
    onClose
}: Props) => {
    return (
        <TriggerWrapperV2 isOpen={isOpen}>
            <Flex
                componentClasses={cx(styles.flexContainer, componentClasses)}
                style={{minWidth: width}}
                justifyContent="space-between"
            >
                <Label
                    componentClasses={styles.triggerTitle}
                    textColor="primary-500"
                    skin="subtitle-2"
                >
                    {title}
                </Label>

                <Icon
                    icon={icon}
                    iconColor="primary-500"
                    disabled={disabled}
                    onClick={e => onClose(e)}
                    style={iconStyle}
                />
            </Flex>
        </TriggerWrapperV2>
    );
};
